import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles({
  imageControlsClose: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: '100',
    bottom: '160px',
    right: '32px',
    width: '40px',
    height: '40px',
    borderRadius: '40px',
    backgroundColor: '#E3E3E3',
  },
  imageControls: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    zIndex: '100',
    bottom: '40px',
    right: '32px',
    width: '40px',
    borderRadius: '40px',
    backgroundColor: '#E3E3E3',
  },
  imageIconSave: {
    width: '20px'
  },
  '@keyframes rotate': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  imageIconButton: {
    '&.loading': {
      opacity: 0.4,
      animation: `$rotate 3s linear infinite`,
      pointsEvent: 'none'
    },
    '&:disabled': {
      opacity: 0.4,
    },
  },
  cropperWrapper: {
    '& .reactEasyCrop_CropArea': {
      boxShadow: 'none !important',
      border: 'none',
    }
  }
});
